export default {

	areSettingsLoaded(state) {
		return Boolean(state.settings?.rules);
	}
};
